import DetailChannelLogo from '@components/atoms/images/detailChannelLogo';
import DetailContext from '@shared/components/utils/context/detailContext';
import DetailIconsContainer from '@components/atoms/container/detailIconsContainer';
import DetailPoster from '@components/atoms/images/detailPoster';
import { useContext } from 'react';

export default function DetailIcons() {
  const { assetInfo } = useContext(DetailContext);
  if (assetInfo) {
    const { channelLogo, poster } = assetInfo;
    return (
      <DetailIconsContainer id='detailIcons'>
        <DetailChannelLogo src={channelLogo || ''} />
        <DetailPoster src={poster} />
      </DetailIconsContainer>
    );
  }
}
